export const ReferralProgramHistoryStatus = {
  None: 0,
  Added: 1,
  Sent: 2,
  Purchased: 3,
  Engaged: 4
}

export const ReferralShareType = {
  Individual: 'individual',
  Facebook: 'facebook'
}

export const ReferralProgramType = {
  Empty: 0, // sync with old cersions
  NonMonetary: 1,
  ReferralAward: 2,
  GiveAndGet: 3,
  GiveAndGetAndLoyalty: 4
}

export const ReferralPanelContentType = {
  ReferralAwardAndNoReferrals: 1,
  ReferralAwardAndReferrals: 4,
  ReferralAwardAndPendingRewards: 7,

  NonMonetaryAndNoReferrals: 2,
  NonMonetaryAndReferrals: 5,
  NonMonetaryAndPendingRewards: 8,

  GiveAndGetAndNoReferrals: 3,
  GiveAndGetAndReferrals: 6,
  GiveAndGetAndPendingRewards: 9
}

export const ReferralConditions = {
  noReferralsYet: 1,
  referralsExistButNonePurchased: 2,
  milestoneComplete: 3,
  oneAwayFromMilestone: 4,
  inProgress: 5
}

export const AddReferralStep = {
  NumberEntered: 'NumberEntered',
  NoNumberEntered: 'NoNumberEntered'
}



// WEBPACK FOOTER //
// ./scripts/src/shared/enums/referral.enum.js